/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataAccessGroupCode {
    ALL_PAYMARKETS = 'all_paymarkets',
    NONE_PAYMARKETS = 'none_paymarkets',
}
